import { Card, Col, Form, Input, Layout, Row, Switch } from "antd";
import { toNumber } from "lodash";
import includes from "lodash/includes";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormActionButton from "src/components/common/FormActionButton";
import { messages } from "src/constants/messages";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import { MessageStatusError } from "src/util/MessageStatus";

const FormItem = Form.Item;
const initialState = {
  tenChucVu: "",
  maChucVu: "",
  isLanhDao: true,
};

const ChucVuForm = ({ status }: any) => {
  const { isActive } = status;
  const navigate = useNavigate();
  const location = useLocation();
  const [type, setType] = useState("new");
  const [fieldTouch, setFieldTouch] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingButtonClose, setLoadingButtonClose] = useState(false);
  const [form] = Form.useForm();
  const { tenChucVu, maChucVu, isLanhDao } = initialState;
  const { validateFields, resetFields, setFieldsValue } = form;
  const { id } = useParams();

  useEffect(() => {
    if (isActive) {
      const load = () => {
        if (includes(location.pathname, "them-moi")) {
          setType("new");
        } else {
          setType("edit");
          getInfo();
        }
      };
      load();
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["infoChucVu"]);
    };
  }, []);

  /**
   * getInfo : Lấy thông tin
   * @memberof  ChucVuForm
   */
  const getInfo = async () => {
    if (location.state && location.state.itemData) {
      // Nếu có dữ liệu truyền sang
      const res = location.state.itemData;
      setFieldsValue({
        chucvu: res,
      });
    } else {
      const configAPI = {
        url: `api/hethongchucvus/${id}`,
        method: "GET",
        value: "",
        apiType: "DETAIL",
        getName: "infoChucVu",
      };
      const response = await apiCaller(configAPI);
      try {
        if (
          response?.data &&
          (response.status === 200 || response.status === 201)
        ) {
          setFieldsValue({
            chucvu: response.data,
          });
        } else {
          MessageStatusError(toNumber(response?.status));
        }
      } catch (error) {
        // Xử lý lỗi khi lưu dữ liệu không thành công
      }
    }
  };

  /**
   * goBack : quay lại trang danh sách
   * @memberof  ChucVuForm
   */
  const goBack = () => {
    navigate("/quan-tri/chuc-vu");
  };

  /**
   * save: Lưu
   * @memberof ChucVuForm
   */
  const save = () => {
      validateFields()
        .then((values) => {
          setLoadingButton(true);
          saveData(values, false);
        })
        .catch(() => {
          setLoadingButton(false);
        });
  };

  /**
   * saveAndClose: Lưu và đóng
   * @memberof ChucVuForm
   */
  const saveAndClose = () => {
      validateFields()
        .then((values) => {
          setLoadingButton(true);
          saveData(values, true);
        })
        .catch(() => {
          setLoadingButton(false);
        });
  };

  /**
   * saveData: Lưu dữ liệu
   * @param {object} values
   * @param {boolean} saveQuit
   * @memberof ChucVuForm
   */
  const saveData = async (values: any, saveQuit = false) => {
    const data = values.chucvu;
    data.isSuDung = true;
    try {
      let configAPI;
      if (type === "new") {
        configAPI = {
          url: `api/hethongchucvus/create`,
          method: "POST",
          data: data,
          apiType: "ADD",
          isShowMessage: true,
        };
      } else {
        configAPI = {
          url: `api/hethongchucvus/${id}`,
          method: "PUT",
          data: data,
          apiType: "EDIT",
          isShowMessage: true,
        };
      }

      const response = await apiCaller(configAPI);
      if (response?.status === 200 || response?.status === 201) {
        if (saveQuit) {
          goBack();
          setLoadingButtonClose(false);
        } else {
          if (type === "new") {
            resetFields();
          }
          setFieldTouch(false);
          setLoadingButton(false);
        }
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingButton(false);
      }
    } catch (error) {
      setLoadingButton(false);
    }
  };

  const formTitle = type === "new" ? "Thêm mới chức vụ" : "Chỉnh sửa chức vụ";
  return (
    <Layout>
      <div style={{ display: "flex" }}>
        <Col md={12}>
          <h2 style={{ color: "black", fontSize: 20, marginTop: 10 }}>
            {formTitle}
          </h2>
        </Col>
      </div>
      <Card>
        <Form
          className="form-container wrapper-content-inner"
          layout="vertical"
          form={form}
          name="chucvu-control"
          onFieldsChange={() => setFieldTouch(true)}
        >
          <Row gutter={24}>
            <Col md={8} xs={24}>
              <FormItem
                className="ant-input-group"
                label="Tên chức vụ"
                name={["chucvu", "tenChucVu"]}
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: messages.ERROR_REQUIRED,
                  },
                ]}
                initialValue={tenChucVu}
              >
                <Input className="input-item" placeholder="Nhập tên chức vụ" />
              </FormItem>
            </Col>
            <Col md={8} xs={24}>
              <FormItem
                className="ant-input-group"
                label="Mã chức vụ"
                name={["chucvu", "maChucVu"]}
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: messages.ERROR_REQUIRED,
                  },
                ]}
                initialValue={maChucVu}
              >
                <Input className="input-item" placeholder="Nhập mã chức vụ" />
              </FormItem>
            </Col>
            <Col md={8} xs={24}>
              <FormItem
                label="Lãnh đạo"
                name={["chucvu", "isLanhDao"]}
                valuePropName="checked"
                initialValue={isLanhDao}
              >
                <Switch />
              </FormItem>
            </Col>
          </Row>
          <hr/>
          <FormActionButton
            goBack={goBack}
            saveAndClose={saveAndClose}
            disabled={fieldTouch}
            save={save}
            type={type}
            loadingButton={loadingButton}
            loadingButtonClose={loadingButtonClose}
          />
        </Form>
      </Card>
    </Layout>
  );
};

export default ChucVuForm;
